import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export default function ConvertTrialDialog({ business, onClose, onConverted }) {
  const { getAuthHeader } = useAuth();
  const [clear, setClear] = useState(true);
  const [saving, setSaving] = useState(false);

  const convert = async () => {
    setSaving(true);
    try {
      const r = await axios.post(`${API}/platform/businesses/${business.id}/convert`, { clear_demo_data: clear }, { headers: getAuthHeader() });
      toast.success(`${business.name} is now a paying customer${r.data.onboarding_invoice ? ` — onboarding invoice ${money(r.data.onboarding_invoice)} created` : ''}`);
      onConverted();
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Could not convert');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!business} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="convert-trial-dialog">
        <DialogHeader>
          <DialogTitle>Convert {business?.name} to a paying customer</DialogTitle>
          <DialogDescription>
            Their login stays the same. Billing starts at {money(business?.monthly_fee)} + GST/month ({business?.store_count} store{business?.store_count === 1 ? '' : 's'}) plus a {money(business?.onboarding_fee)} + GST onboarding invoice.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 text-sm">
          <label className="flex items-start gap-2 rounded-lg border p-3 cursor-pointer">
            <input type="radio" name="demo" checked={clear} onChange={() => setClear(true)} className="mt-0.5" data-testid="convert-clear" />
            <span><b>Fresh start</b> — remove the sample sales, customers and stock. The catalogue and any prices they changed are kept.</span>
          </label>
          <label className="flex items-start gap-2 rounded-lg border p-3 cursor-pointer">
            <input type="radio" name="demo" checked={!clear} onChange={() => setClear(false)} className="mt-0.5" data-testid="convert-keep" />
            <span><b>Keep everything</b> — sample data stays in their reports.</span>
          </label>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={convert} disabled={saving} className="bg-[#1B5E20] hover:bg-[#2E7D32]" data-testid="convert-submit">
            {saving ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Converting…</> : 'Convert'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
